import { useTranslation } from 'react-i18next';
import PageHeader from '@/components/ui/PageHeader';
import FeedbackBoard from '@/components/feedback/FeedbackBoard';

/** Раздел «Замечания» в меню (как в zakup.starec.ai): доска замечаний с кнопкой «Запустить исправление» для робота. */
export default function FeedbackPage() {
  const { t } = useTranslation();
  return (
    <div>
      <PageHeader eyebrow={t('fbp.eyebrow')} title={t('fbp.title')} description={t('fbp.description')} />
      <FeedbackBoard />
    </div>
  );
}
